import { Directive, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';


@Directive()
export abstract class UnsubscribeComponent implements OnDestroy {

  protected clearSubscriptions$ = new Subject<void>();

  constructor() {
    this.clearSubscriptions$ = new Subject<void>();
  }

  public ngOnDestroy(): void {
    this.clearSubscriptions$.next();
    this.clearSubscriptions$.complete();
  }

}
